export default __webpack_public_path__ + "static/7-ea09deeaf20c435b778ce54f9605089e.gif";